module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "primeModal",
    attrs: {
      "no-close-on-backdrop": "",
      "no-close-on-esc": "",
      "centered": "",
      "body-class": "prime-body",
      "hide-header": "",
      "hide-footer": ""
    }
  }, [_c('div', {
    staticClass: "prime-container"
  }, [_c('img', {
    staticClass: "prime-logo",
    attrs: {
      "src": "/static/images/logo-prime.svg",
      "alt": "logo"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "prime-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t(_vm.benefitTitle))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "prime-section"
  }, [(_vm.isUnsupportText) ? _c('div', {
    staticClass: "unsupport-text"
  }, [_vm._v(" " + _vm._s(_vm.unsupportText))]) : _vm._l((_vm.benefitItems), function(value, index) {
    return _c('div', {
      key: index,
      staticClass: "benefit-items"
    }, [_c('img', {
      staticClass: "check-icon",
      attrs: {
        "src": value.icon,
        "alt": "icon"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "benefit-text"
    }, [_vm._v("\n          " + _vm._s(value.text) + "\n        ")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "prime-btn-container"
  }, [_c('button', {
    staticClass: "prime-ok-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('okModal')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('prime.notice.confirm')))]), _vm._v(" "), _c('button', {
    staticClass: "prime-close-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closeModal')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('prime.notice.cancel')))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-756521fd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/cat-main/components/PrimeModal.vue
// module id = 1592
// module chunks = 1